<template>
  <section>
    <!-- <v-btn @click="copyUserData">++</v-btn> -->
    <router-view></router-view>

    <!-- Internet Status Indicator -->
    <div class="internet-status-indicator" :title="internetStatusTooltip">
      Таны интернетийн хурд:
      <v-icon size="20" :style="{ color: internetStatusColor + ' !important' }">
        {{ internetStatusIcon }}
      </v-icon>
      <span
        v-if="internetCheck && !internetCheck.error && $store.state.isLocalHost"
        class="internet-speed-text"
      >
        {{ internetCheck.speedMbps }} Mbps
      </span>
    </div>

    <v-dialog
      v-if="announcements && announcements.length > 0 && userData"
      width="600"
      v-model="announcementDialog"
      :scrollable="false"
      persistent
    >
      <v-card class="card-shadow pa-4 px-2">
        <v-card height="500" style="overflow-y: auto">
          <v-card-title class="text-h4 py-1">Зарлал</v-card-title>
          <v-divider></v-divider>
          <v-card-text
            v-for="(announcement, aindex) in announcements"
            :key="'announcement-' + aindex"
          >
            <v-row>
              <v-col cols="12" class="text-h6 blue--text">
                <div v-html="announcement.title"></div>
              </v-col>
              <v-col cols="12">
                <div v-html="announcement.description"></div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
        <v-row no-gutters class="mt-4 px-2">
          <v-spacer></v-spacer>
          <v-btn
            class="bg-gradient-info white--text"
            @click="markAnnouncementsAsSeen()"
            >Хаах</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>

    <!-- "_messagesForTeachers" collection, one doc per message:
    {
USERNAME,
answers,
createdAt,
question,
seen,
teacherPath (path of the teacher doc the message is for)
    }
  -->
    <v-dialog
      v-if="unseenSystemMessages.length > 0"
      width="60%"
      v-model="systemMessagesDialog"
      :scrollable="false"
      persistent
    >
      <v-card class="card-shadow pa-4 px-2">
        <v-card height="500" style="overflow-y: auto">
          <v-card-title
            class="text-h4 py-1"
            @click="markSystemMessagesAsSeen(false)"
            >Мэдэгдэл</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text
            v-for="(msg, mindex) in unseenSystemMessages"
            :key="'sysmsg-' + mindex"
          >
            <v-row>
              <v-col cols="12" class="blue--text">
                <p class="text-h5" v-html="msg.question"></p>
              </v-col>
              <v-col cols="12" v-if="msg.answers">
                <p class="text-h6" v-html="msg.answers"></p>
              </v-col>
              <v-col cols="12" v-if="msg.answerImageUrl">
                <v-img
                  :src="driveImageUrl(msg.answerImageUrl)"
                  max-height="300"
                  contain
                  style="cursor: pointer"
                  @click="openFullImage(driveImageUrl(msg.answerImageUrl))"
                ></v-img>
              </v-col>
              <v-col cols="12" v-if="msg.answerVideoUrl">
                <div
                  v-if="extractYouTubeId(msg.answerVideoUrl)"
                  style="position: relative; padding-bottom: 56.25%; height: 0"
                >
                  <iframe
                    :src="youTubeEmbedUrl(msg.answerVideoUrl)"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                    "
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <a v-else :href="msg.answerVideoUrl" target="_blank">{{
                  msg.answerVideoUrl
                }}</a>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
        <v-row no-gutters class="mt-4 px-2">
          <v-spacer></v-spacer>
          <v-btn
            class="bg-gradient-info white--text"
            @click="markSystemMessagesAsSeen(true)"
            >Хаах</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fullImageDialog" max-width="90vw">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Зураг</span>
          <v-btn icon @click="fullImageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4 text-center">
          <v-img
            v-if="fullImageUrl"
            :src="fullImageUrl"
            contain
            max-height="80vh"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {
      teacher: null,
      announcementDialog: false,
      announcements: null,
      pingInterval: null,
      systemMessagesDialog: false,
      systemMessagesUnsub: null,
      // USERNAME (or doc path) the listener above is for
      systemMessagesKey: null,
      fullImageDialog: false,
      fullImageUrl: null,
    };
  },

  watch: {
    $route: {
      handler() {
        if (this.announcements) {
          this.announcements = this.announcements.filter(
            (x) => x.seen == false
          );
          if (this.announcements.length > 0 && this.userData) {
            this.announcementDialog = true;
          }
        }
        if (this.unseenSystemMessages.length > 0) {
          this.systemMessagesDialog = true;
        }
        console.log(
          "route changed in App.vue",
          sessionStorage.getItem("reloadAfterNavigation")
        );
        // Check if we need to reload after navigation
        if (sessionStorage.getItem("reloadAfterNavigation") === "true") {
          sessionStorage.removeItem("reloadAfterNavigation");
          location.reload();
          return;
        }
      },
      deep: true,
    },
    // Messages left for this user live in the "_messagesForTeachers"
    // collection. They are kept realtime on userData._messagesForTeachers,
    // which the drawers also read.
    userData: {
      immediate: true,
      handler(val) {
        // Matched by USERNAME; a user without one (where() rejects
        // undefined) is matched by the path of their own doc instead.
        // Another account logged in (no page reload): listen for that one.
        const key = val && val.ref ? val.USERNAME || val.ref.path : null;
        if (key !== this.systemMessagesKey && this.systemMessagesUnsub) {
          this.systemMessagesUnsub();
          this.systemMessagesUnsub = null;
          this.systemMessagesDialog = false;
        }
        this.systemMessagesKey = key;
        if (val && val.ref && !this.systemMessagesUnsub) {
          const messages = fb.db.collection("_messagesForTeachers");
          this.systemMessagesUnsub = (
            val.USERNAME
              ? messages.where("USERNAME", "==", val.USERNAME)
              : messages.where("teacherPath", "==", val.ref.path)
          ).onSnapshot(
              (snap) => {
                this.$set(
                  this.userData,
                  "_messagesForTeachers",
                  snap.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                    ref: doc.ref,
                  }))
                );
                if (this.unseenSystemMessages.length > 0) {
                  this.systemMessagesDialog = true;
                }
              },
              (error) =>
                console.error("_messagesForTeachers listener failed:", error)
            );
        }
      },
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    systemMessages() {
      return (this.userData && this.userData._messagesForTeachers) || [];
    },
    unseenSystemMessages() {
      return this.systemMessages.filter(
        (m) => !m.seen && this.userData.USERNAME == m.USERNAME
      );
    },
    internetCheck() {
      return this.$store.state.internetCheck;
    },
    internetStatusIcon() {
      if (!this.internetCheck || this.internetCheck.error) {
        return "mdi-wifi-off";
      }
      const type = this.internetCheck.effectiveType;
      if (type === "4g") return "mdi-wifi-strength-4";
      if (type === "3g") return "mdi-wifi-strength-3";
      if (type === "2g") return "mdi-wifi-strength-2";
      if (type === "slow-2g") return "mdi-wifi-strength-1";
      return "mdi-wifi-strength-1";
    },
    internetStatusColor() {
      if (!this.internetCheck || this.internetCheck.error) {
        return "red";
      }
      const type = this.internetCheck.effectiveType;
      if (type === "4g") return "green";
      if (type === "3g") return "orange";
      if (type === "2g") return "orange";
      if (type === "slow-2g") return "orange";
      return "red";
    },
    internetStatusTooltip() {
      if (!this.internetCheck) return "Checking connection...";
      if (this.internetCheck.error) return "Offline - Connection failed";
      return `${
        this.internetCheck.effectiveType?.toUpperCase() || "N/A"
      } | Ping: ${this.internetCheck.ping}ms | Speed: ${
        this.internetCheck.speedMbps
      } Mbps`;
    },
  },
  methods: {
    // Check internet connection using Navigator Connection API
    async checkInternetPing() {
      try {
        // 1. Measure ping with small request
        const pingStart = performance.now();
        await fetch("https://www.google.com/favicon.ico", {
          mode: "no-cors",
          cache: "no-store",
        });
        const pingEnd = performance.now();
        const ping = Math.round(pingEnd - pingStart);

        // 2. Get bandwidth estimate from Navigator Connection API
        let speedMbps = 0;
        let effectiveType = null;
        if (navigator.connection) {
          speedMbps = navigator.connection.downlink || 0; // Mbps
          effectiveType = navigator.connection.effectiveType; // 4g, 3g, 2g, slow-2g
        }

        // console.log(navigator.connection);

        const internetCheck = {
          ping,
          speedMbps: parseFloat(speedMbps.toFixed(2)),
          effectiveType,
          checkedAt: new Date(),
        };

        this.$set(this.$store.state, "internetCheck", internetCheck);

        // console.log(
        //   `[Internet] Ping: ${ping}ms | Download: ${speedMbps.toFixed(2)} Mbps | Navigator: ${navigatorSpeed ? navigatorSpeed + ' Mbps' : 'N/A'} | Type: ${effectiveType || 'N/A'} | Strength: ${strength}`
        // );
      } catch (error) {
        this.$set(this.$store.state, "internetCheck", {
          error: true,
          message: "Connection failed or offline",
          checkedAt: new Date(),
        });
        console.log("[Internet] Connection failed or offline", error);
      }
    },
    markAnnouncementsAsSeen() {
      if (this.userData) {
        var batch = fb.db.batch();
        this.announcements.forEach((announcement) => {
          announcement.seen = true;
          announcement.ref
            .collection("seen")
            .doc(String(this.userData.id))
            .set(
              {
                seen: true,
                createdAt: new Date(),
                userRef:
                  this.userData && this.userData.ref ? this.userData.ref : null,
                DISPLAY_NAME:
                  this.userData && this.userData.DISPLAY_NAME ? null : null,
                FIRST_NAME:
                  this.userData && this.userData.FIRST_NAME
                    ? this.userData.FIRST_NAME
                    : this.userData && this.userData.firstName
                    ? this.userData.firstName
                    : null,
                LAST_NAME:
                  this.userData && this.userData.LAST_NAME
                    ? this.userData.LAST_NAME
                    : this.userData && this.userData.lastName
                    ? this.userData.lastName
                    : null,
                schoolName:
                  this.userData && this.userData.school
                    ? this.userData.school.name
                    : null,
                schoolRef:
                  this.userData && this.userData.school
                    ? this.userData.school.id
                    : null,
              },
              { merge: true }
            );
        });
        batch.commit().then(() => {
          this.announcementDialog = false;
        });
      } else {
        this.announcementDialog = false;
      }
    },
    // A shared Drive link (.../file/d/ID/view or .../open?id=ID) isn't a
    // directly loadable image src - Drive's thumbnail endpoint is.
    driveImageUrl(url) {
      if (!url) return url;
      if (url.includes("drive.google.com")) {
        const match =
          url.match(/\/d\/([a-zA-Z0-9-_]+)/) ||
          url.match(/[?&]id=([a-zA-Z0-9-_]+)/);
        if (match && match[1]) {
          return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1000`;
        }
      }
      return url;
    },
    openFullImage(url) {
      this.fullImageUrl = url;
      this.fullImageDialog = true;
    },
    extractYouTubeId(url) {
      if (!url) return null;
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },
    youTubeEmbedUrl(url) {
      const videoId = this.extractYouTubeId(url);
      return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    },
    markSystemMessagesAsSeen(savee) {
      if (!this.userData || !this.userData.ref) {
        this.systemMessagesDialog = false;
        return;
      }
      if (savee) {
        const batch = fb.db.batch();
        this.unseenSystemMessages.forEach((m) => {
          batch.update(m.ref, { seen: true, seenAt: new Date() });
        });
        batch.commit().then(() => {
          this.systemMessagesDialog = false;
        });
      } else {
        this.systemMessagesDialog = false;
      }
    },
    async copyVirtualSchool() {
      var sss = [
        {
          school: "Баянзүрх сумын хүүхдийн цэцэрлэг",
          contact: "Ч.Дэлгэрмаа",
          phone: "80301310",
          email: "Sob.Baynzurkh@gmail.com",
          subdomain: "bayanzurkh.sub@moes.edu.mn",
        },
        {
          school: "Бүрэнтогтох сумын хүүхдийн цэцэрлэг",
          contact: "Э.Дариймаа",
          phone: "91912966",
          email: "dariimaaenkhamgalan@gmail.com",
          subdomain: "burentogtokh.sub@moes.edu.mn",
        },
        {
          school: "Жаргалант 1 хүүхдийн цэцэрлэг",
          contact: "Ш.Бурмаа",
          phone: "94156656",
          email: "Jargalantsub65@gmail.com",
          subdomain: "jargalant1.sub@moes.edu.mn",
        },
        {
          school: "Жаргалант 2 хүүхдийн цэцэрлэг",
          contact: "Л.Санжмаа",
          phone: "95151599",
          email: "subjargalant2@gmail.com",
          subdomain: "jargalant2.sub@moes.edu.mn",
        },
        {
          school: "Их-Уулын хүүхдийн цэцэрлэг",
          contact: "С.Тайванжаргал",
          phone: "99380838",
          email: "sodkhoitaivanjargal@gmail.com",
          subdomain: "ikhuul.sub@moes.edu.mn",
        },
        {
          school: "Могойн хүүхдийн цэцэрлэг",
          contact: "Б.Мөнхдэлгэр",
          phone: "99388216",
          email: "mogoisob1234@gmail.com",
          subdomain: "mogoi.sub@moes.edu.mn",
        },
        {
          school: "Рашаант хүүхдийн цэцэрлэг",
          contact: "Ч.Отгон-Эрдэнэ",
          phone: "99236197",
          email: "Chotgoo175@gmail.com",
          subdomain: "rashaant.sub@moes.edu.mn",
        },
        {
          school: "Галтын хүүхдийн цэцэрлэг",
          contact: "Д.Түвшинбаяр",
          phone: "88292526",
          email: "tuvshuu2526@gmail.com",
          subdomain: "galt.sub@moes.edu.mn",
        },
        {
          school: "Ренчинлхүмбэ хүүхдийн цэцэрлэг",
          contact: "Отгонням",
          phone: "89897393",
          email: "Subrl280@gmail.com",
          subdomain: "renchinlkhumbe.sub@moes.edu.mn",
        },
        {
          school: "Тариалан хүүхдийн цэцэрлэг",
          contact: "Х.Шүрэнцэцэг",
          phone: "88088627",
          email: "sshur9998@gmail.com",
          subdomain: "tarialan.sub@moes.edu.mn",
        },
        {
          school: "Тосонцэнгэл хүүхдийн цэцэрлэг",
          contact: "Ц.Нямханд",
          phone: "80000398",
          email: "nyamhandtse.0828@gmail.com",
          subdomain: "tosontsengel.sub@moes.edu.mn",
        },
        {
          school: "Төмөрбулаг хүүхдийн цэцэрлэг",
          contact: "А.Амаржаргал",
          phone: "88263506",
          email: "sob.tumurbulag.71@gmail.com",
          subdomain: "tomorbulag.sub@moes.edu.mn",
        },
        {
          school: "Түнэл хүүхдийн цэцэрлэг",
          contact: "Б.Эрдэнэцэцэг",
          phone: "89698095",
          email: "batchuluunerdenetsetseg2016@gmail.com",
          subdomain: "tunel.sub@moes.edu.mn",
        },
        {
          school: "Улаан-Уул хүүхдийн цэцэрлэг",
          contact: "Б.Сэндэрмаа",
          phone: "86614645",
          email: "sob.ulaanuul@gmail.com",
          subdomain: "ulaanuul.sub@moes.edu.mn",
        },
        {
          school: "Ханх хүүхдийн цэцэрлэг",
          contact: "Ж.Уранчимэг",
          phone: "88663874",
          email: "hanhcob576@gmail.com",
          subdomain: "khankh.sub@moes.edu.mn",
        },
        {
          school: "Хатгал хүүхдийн цэцэрлэг",
          contact: "Б.Ууганцэцэг",
          phone: "88506696",
          email: "turtogtokherdenechimeg@gmail.com",
          subdomain: "khatgal.sub@moes.edu.mn",
        },
        {
          school: "Цагаан-Уул1 хүүхдийн цэцэрлэг",
          contact: "Г.Азбаяр",
          phone: "88071758",
          email: "anxuush0626@gmail.com",
          subdomain: "tsagaanuul1.sub@moes.edu.mn",
        },
        {
          school: "Цагаан-Уул 2 хүүхдийн цэцэрлэг",
          contact: "Х.Пүрэвбат",
          phone: "99589003",
          email: "lsaihnaaaa.024@gmail.com",
          subdomain: "tsagaanuul2.sub@moes.edu.mn",
        },
        {
          school: "Цагааннуур хүүхдийн цэцэрлэг",
          contact: "Т.Цэндмаа",
          phone: "99664950",
          email: "tumurtsendmaa@gmail.com",
          subdomain: "tsagaannuur.sub@moes.edu.mn",
        },
        {
          school: "Цагаан-Үүр хүүхдийн цэцэрлэг",
          contact: "Н.Соёл-Эрдэнэ",
          phone: "86362558",
          email: "soyoloo2558@gmail.com",
          subdomain: "tsagaanuur.sub@moes.edu.mn",
        },
        {
          school: "Цэцэрлэг хүүхдийн цэцэрлэг",
          contact: "Г.Даваажав",
          phone: "80799905",
          email: "davaazavgurdorz@gmail.com",
          subdomain: "tsetserleg.sub@moes.edu.mn",
        },
        {
          school: "Чандмань-Өндөр хүүхдийн цэцэрлэг",
          contact: "Б.Өлзий",
          phone: "99568952",
          email: "unjii1006@gmail.com",
          subdomain: "chandmaniondor.sub@moes.edu.mn",
        },
        {
          school: "Шинэ-Идэр хүүхдийн цэцэрлэг",
          contact: "Р.Амарбаясгалан",
          phone: "80883691",
          email: "sub.shineider@gmail.com",
          subdomain: "shineider.sub@moes.edu.mn",
        },
        {
          school: "Эрдэнэбулган хүүхдийн цэцэрлэг",
          contact: "М.Алтантуяа",
          phone: "89989101",
          email: "erdenebulgan.enerel8@gmail.com",
          subdomain: "erdenebulgan.sub@moes.edu.mn",
        },
        {
          school: "Хөх сувд хүүхдийн цэцэрлэг",
          contact: "Г.Мөнхцэцэг",
          phone: "99069790",
          email: "sob.murun1@gmail.com",
          subdomain: "moron1.sub@moes.edu.mn",
        },
        {
          school: "Мөрөн 2-р цэцэрлэг",
          contact: "Т.Мөнхчимэг",
          phone: "88060927",
          email: "tumurbatmunkhchimeg2@gmail.com",
          subdomain: "moron2.sub@moes.edu.mn",
        },
        {
          school: "Өсөх нахиа хүүхдийн цэцэрлэг",
          contact: "Д.Нарантуяа",
          phone: "80069694",
          email: "naraa.90067676@gmail.com",
          subdomain: "moron3.sub@moes.edu.mn",
        },
        {
          school: "Солонго хүүхдийн цэцэрлэг",
          contact: "Ж.Долгорсүрэн",
          phone: "89606899",
          email: "dolgorsvrenjigjidsvren@gmail.com",
          subdomain: "moron4.sub@moes.edu.mn",
        },
        {
          school: "Эрдмийн түлхүүр",
          contact: "Б.Нямжав",
          phone: "99066283",
          email: "sob.moron5@gmail.com",
          subdomain: "moron5.sub@moes.edu.mn",
        },
        {
          school: "Ирээдүйн хүчтэн цэцэрлэг",
          contact: "Н.Оюунбилэг",
          phone: "99020813",
          email: "Margadoogii9@gmail.com",
          subdomain: "moron6.sub@moes.edu.mn",
        },
        {
          school: "Энх-Өргөө цэцэрлэг",
          contact: "Д.Ундармаа",
          phone: "99040633",
          email: "undarkaa@gmail.com",
          subdomain: "moron7.sub@moes.edu.mn",
        },
        {
          school: "Нархан цэцэрлэsг",
          contact: "Б.Эрдэнэцэцэг",
          phone: "88002495",
          email: "sob.moron8@gmail.com",
          subdomain: "moron8.sub@moes.edu.mn",
        },
        {
          school: "Танилхан цэцэрлэг",
          contact: "П.Наранхүү",
          phone: "89917096",
          email: "naraanar96@gmail.com",
          subdomain: "moron9.sub@moes.edu.mn",
        },
        {
          school: "Цэнхэр дэлхий цэцэрлэг",
          contact: "Д.Юмжирдулам",
          phone: "88064650",
          email: "b.enhtsetseg70@gmail.com",
          subdomain: "moron10.sub@moes.edu.mn",
        },
        {
          school: "Мөрөнжин цэцэрлэг",
          contact: "Б.Оюунцэцэг",
          phone: "88383847",
          email: "sob.moron11@gmail.com",
          subdomain: "moron11.sub@moes.edu.mn",
        },
        {
          school: "Бөмбөлөг цэцэрлэг",
          contact: "С.Гүндсамба",
          phone: "88019827",
          email: "sengeegundee@gmail.com",
          subdomain: "moron12.sub@moes.edu.mn",
        },
        {
          school: "Бүрэнхаан цэцэрлэг",
          contact: "Г.Ганчимэг",
          phone: "99389599",
          email: "sob.13tsetserleg@gmail.com",
          subdomain: "moron13.sub@moes.edu.mn",
        },
        {
          school: "Ивээл цэцэрлэг",
          contact: "П.Байгалмаа",
          phone: "99026478",
          email: "Baigal6478@gmail.com",
          subdomain: "moron14.sub@moes.edu.mn",
        },
        {
          school: "Эрдэм цэцэрлэг",
          contact: "Ө.Сэлэнгэ",
          phone: "99385474",
          email: "uvgiiselengee@gmail.com",
          subdomain: "moron15.sub@moes.edu.mn",
        },
      ];
      console.log("Copying virtual school...");

      var aaa = {
        accountClosed: false,
        createdAt: new Date(),
        deleted: false,
        phone: null,
        email: null,
        firstName: null,
        role: "schooldirector",
        roleName: "Захирал",
        roleRef: fb.db.doc("/xDuties/HGvkl8EcJp6K3qgN1zPw"),
      };
      // var list = ["Эрдмийн далай"];

      var batch = fb.db.batch();
      for (const ss of sss) {
        await fb.db
          .doc("schools/UIm2qYAoZj5h4UTtYQuY")
          .get()
          .then((doc) => {
            let school = doc.data();

            school.name = ss.school;
            school.city = "Xөвсгөл";
            school.cityCode = "02";
            school.isKinderGarten = true;
            school.createdAt = new Date();

            var tmp = ss.contact.split(".");

            aaa.firstName = tmp.length > 1 ? tmp[1] : tmp[0];
            aaa.lastName = tmp.length > 1 ? tmp[0] : null;
            aaa.phone = ss.phone;
            aaa.email = ss.subdomain;
            aaa.email2 = ss.email;

            var schoolRef = fb.db.collection("schools").doc();
            console.log(schoolRef.path, school.name);
            batch.set(schoolRef.collection("teachers").doc(), aaa);
            batch.set(schoolRef, school);
          });
      }
      batch.commit();
    },
    async copyUserData() {
      fb.db
        .doc("/schools/D8uJ7kVXJTK8kqFZnWz3/teachers/0Wi1TNosg7JJJNBXZTwd")
        .get()
        .then((doc) => {
          let ddd = doc.data();
          var ddRef = fb.db
            .collection("/schools/zLtvBvdfZFMoouowJ5g6/teachers")
            .doc();
          console.log(ddRef.path);
          ddRef.set(ddd, { merge: true });
        });
    },
    suuProblems() {
      let problems = [
        // 3, 12345678, 9001, 27000, 6, 27780, 6229653, 58, 11, 55003994,
        7788818, 2702673, 2011,
      ];
      fb.db
        .collectionGroup("classGroups-2025")
        .where("milkConsumptionData.milkCompanyRegNumber", "in", problems)
        .get()
        .then((docs) => {
          var str = "";
          docs.forEach(async (doc) => {
            let cg = doc.data();
            var schoolData = await doc.ref.parent.parent
              .get()
              .then((schoolDoc) => {
                if (schoolDoc.exists) {
                  return schoolDoc.data();
                }
              });
            str += `${cg.milkConsumptionData.milkCompanyRegNumber} \t ${schoolData.name} \t ${cg.STUDENT_GROUP_NAME}\n`;
            console.log(str);
          });
        });
    },
  },
  beforeDestroy() {
    // Clear ping interval when component is destroyed
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
      this.pingInterval = null;
    }
    if (this.systemMessagesUnsub) {
      this.systemMessagesUnsub();
      this.systemMessagesUnsub = null;
    }
  },
  created() {
    // axios
    //   .post(
    //     "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getCollectionLength",
    //     {
    //       collectionRefPath: `classGroups-2025`,
    //       isCollectionGroup: true,
    //       whereConditions: [{ field: "deleted", operator: "!=", value: true }],
    //     },
    //   )
    //   .then((res) => {
    //     console.log(res.data);
    //   });

    // Start internet ping monitoring every 5 seconds
    this.pingInterval = setInterval(() => {
      this.checkInternetPing();
    }, 5000);
    // Run immediately on load
    this.checkInternetPing();

    // this.suuProblems();
    // this.copyVirtualSchool();
    if (this.userData && this.userData.role != "superadmin") {
      fb.db.doc("/_bagshSystemConfigurations/bagshWeb").onSnapshot((doc) => {
        let config = doc.data();
        if (config.forceRefresh == true) {
          window.location.reload();
        }

        if (
          config.forceRefreshCityCode.includes(
            String(this.userData?.school?.cityCode) ||
              String(this.userData?.cityCode)
          )
        ) {
          window.location.reload();
        }

        if (
          config.forceRefreshSchool.includes(String(this.userData?.school?.id))
        ) {
          window.location.reload();
        }

        if (config.forceRefreshUserId.includes(String(this.userData?.id))) {
          window.location.reload();
        }
      });
    }
  },
  mounted() {
    // fb.db
    //   .doc("/_system_info_news2/iEmMhlkU1ScvsuTx6AHX")
    //   .get()
    //   .then((doc) => {
    //     if (doc.exists) {
    //       fb.db.doc("_system_info_news/iEmMhlkU1ScvsuTx6AHX").set(doc.data());
    //     }
    //   });
    setTimeout(() => {
      if (
        this.userData &&
        this.userData.role != "superadmin" &&
        this.userData.role != "student" &&
        this.userData.role != "citymanager"
      ) {
        fb.db.collection("_system_info_news").onSnapshot(async (docs) => {
          var announcements = [];
          docs.forEach((doc) => {
            let announcement = doc.data();
            announcement.id = doc.id;
            announcement.ref = doc.ref;

            announcements.push(announcement);
          });

          this.announcements = [];
          const promises = announcements.map(async (announcement) => {
            await announcement.ref
              .collection("seen")
              .doc(this.userData.id)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  announcement.seen = doc.data().seen;
                } else {
                  announcement.seen = false;
                }

                if (announcement.showUntil && announcement.seen == false) {
                  if (announcement.showUntil.toDate() >= new Date()) {
                    this.announcements.push(announcement);
                  }
                }
              });

            return true;
          });

          await Promise.all(promises);
          this.announcements.sort((a, b) => {
            return b.createdAt - a.createdAt;
          });
          if (this.announcements.length > 0) {
            this.announcementDialog = true;
          } else {
            this.announcementDialog = false;
          }
        });
      }
    }, 1000);
  },
};
</script>

<style scoped>
.internet-status-indicator {
  position: fixed;
  bottom: 1%;
  left: 1%;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: default;
  font-size: 11px;
  transition: all 0.3s ease;
  opacity: 0.8;
  pointer-events: none;
}

.internet-speed-text {
  color: #666;
  font-weight: 500;
}
</style>
